import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { Button } from 'react-bootstrap';
import { LanguagesFetchAPI } from '../../api/Languages';
import LoadingAlert from '../Alerts/LoadingAlert';


// This component is used to select the branchoffice of the user, it is used in the NavBar and in the reports, it is a modal that shows the list of branchoffices of the user and allows to select one, it also allows to select all the branchoffices.
function ModalBranchofficeSelect({ actionSelectBranches }) {
    const [selectedBranches, setSelectedBranches] = useState([]);
    const [allSelected, setAllSelected] = useState(true);
    const [branchofficeName, setBranchofficeName] = useState("Todas las sucursales");
    const [showModalBranchofficeslect, setShowModalBranchofficesselect] = useState(false);
    const [statusLanguage, setStatusLanguage] = useState(0)

    //We get the user data 
    let user = JSON.parse(localStorage.getItem('user'))
    let token = localStorage.getItem('x-access-token');
    const [userBranchoffices, setUserBranchs] = useState([]);

    //Helpers 
    const toggleBranch = (branch) => {
        const exists = selectedBranches.find(b => b.code === branch.code);

        let updated = [];

        if (exists) {
            updated = selectedBranches.filter(b => b.code !== branch.code);
        } else {
            updated = [...selectedBranches, branch];
        }

        setSelectedBranches(updated);
        setAllSelected(false);
    };

    // This function is used to confirm the selection of the branchoffices, it is called when the user clicks on the confirm button, it saves the selected branchoffices in the localStorage and calls the actionSelectBranches function with the selected branchoffices.
    const confirmSelection = () => {
        if (allSelected || selectedBranches.length === 0) {
            localStorage.setItem("report_branchoffices_mode", "all");
            localStorage.setItem("report_branchoffices", JSON.stringify([]));
            setBranchofficeName("Todas las sucursales");
            actionSelectBranches([]);
        } else {
            localStorage.setItem("report_branchoffices_mode", "custom");
            localStorage.setItem("report_branchoffices", JSON.stringify(selectedBranches));
            setBranchofficeName(
                selectedBranches.length === 1
                    ? selectedBranches[0].branchoffice_name
                    : `${selectedBranches.length} sucursales`
            );
            actionSelectBranches(selectedBranches);
        }

        setShowModalBranchofficesselect(false);
    };

    {/*view branchoffice*/ }
    const viewBranch = () => {
        const listItems = userBranchoffices.map((branch, index) => (
            <>
                {/* <div className='m-3'>
                    <div className='btn btn-outline-primary  d-block border border-3 rounded-pill p-3 ' onClick={() => (safeSelect(branch))}>
                        <span className='p-3  text-wrap px-3'>{branch.branchoffice_name}</span>
                    </div>
                </div> */}

                <label className="btn-branchs card-title rounded-3  p-2 border border-primary text-center fw-semibold w-100 text-primary" translate='no'
                    for={branch.branchoffice_name + index}>
                    <input
                        type="checkbox"
                        checked={selectedBranches.some(b => b.code === branch.code)}
                        onChange={() => toggleBranch(branch)}
                    />
                    <span> {branch.branchoffice_name}</span>
                </label>
            </>
        ));
        return (listItems)
    }

    useEffect(() => {
        try {
            setUserBranchs(user.branchoffices || []);

            const mode = localStorage.getItem("report_branchoffices_mode");
            const stored = JSON.parse(localStorage.getItem("report_branchoffices") || "[]");

            if (mode === "custom" && stored.length > 0) {
                setAllSelected(false);
                setSelectedBranches(stored);
                setBranchofficeName(
                    stored.length === 1 ? stored[0].branchoffice_name : `${stored.length} sucursales`
                );
                actionSelectBranches(stored);
            } else {
                setAllSelected(true);
                setSelectedBranches([]);
                setBranchofficeName("Todas las sucursales");
                actionSelectBranches([]);
            }
        } catch (err) { }
    }, []);
    return (
        <>

            <button class="btn-branchs card-title rounded-3  p-1 border border-primary text-center " onClick={() => (setShowModalBranchofficesselect(true), console.log(userBranchoffices))}>

                <small class="d-block fw-semibold" role='button'>

                    <i class="uil uil-store-alt"></i> Sucursal</small>
                <span class="fw-semibold" role='button' >
                    {branchofficeName}
                </span>
            </button>

            <Modal
                centered
                className='modal-dialog-kk'
                size="md"
                show={showModalBranchofficeslect}
                onHide={() => setShowModalBranchofficesselect(false)}>
                <Modal.Body>

                    <div className='idioma-sp position-relative '>
                        <section className="form-signin-sp bg-white border-0">
                            <h2 className="title-main-login  text-center ">      <i class="uil uil-store-alt"></i>Sucursales</h2>
                            <div className=' pb-4' >
                                <label className="form-label fw-normal text-gray-600">
                                    Lista de sucursales
                                </label>
                                <div className='branch-wrapper  no-scroll'>
                                    <div className='d-flex flex-column gap-3 p-2 bg-body' >

                                        <label className="btn-branchs card-title rounded-3  p-2 border border-primary text-center fw-semibold w-100 text-primary" for="all">
                                            <input
                                                type="checkbox"
                                                checked={allSelected}
                                                onChange={() => {
                                                    setAllSelected(true);
                                                    setSelectedBranches([]);
                                                }}
                                            />
                                            <span>Todas las sucursales</span>
                                        </label>
                                        {viewBranch()}
                                        <Button onClick={confirmSelection}>Aplicar</Button>
                                    </div>
                                </div>
                                <div className='d-block text-center mt-3 opacity-50'>
                                    <i class="uil uil-info-circle"></i>
                                    Escoge  la sucursal de tu preferencia.
                                </div>
                            </div>
                        </section>
                        <div className='position-absolute top-0 start-100 translate-middle mt-2 '>
                            <div className='me-3'>
                                <button class="btn btn-outline-secondary border-0 bg-light text-secondary rounded-circle p-2 lh-1" type="button" onClick={() => (setShowModalBranchofficesselect(false))} title='Cerrar'>
                                    <i class="uil uil-multiply"></i>
                                    <span class="visually-hidden">Dismiss</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalBranchofficeSelect